import React, { Component } from 'react';
import { Page, Layout, Card, FormLayout, TextField, Banner, SettingToggle, Text, Checkbox, Button, LegacyStack, ButtonGroup, PageActions, TextContainer, Select, Tooltip, InlineStack, Icon  } from '@shopify/polaris';
import { InfoMinor } from '@shopify/polaris-icons';
import { SkeletonPageCustom } from './SkeletonPageCustom';
import { ColorPickerCustom } from './ColorPickerCustom';
import { DesktopMajor, MobileMajor } from '@shopify/polaris-icons';
import { fetchApi } from './helpers/fetchApi';

export class QuickView extends Component {

    constructor(props, ref) {
        super(props);
        props.setIsLoading(true);

        this.saveChanges = this.saveChanges.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.discardChanges = this.discardChanges.bind(this);
        this.togglePreviewActive = this.togglePreviewActive.bind(this);

        this.state = { initState: {}, model: {}, loading: true, previewActive: true, previewDesktop: true };
    }

    componentDidMount() {
        this.populateData();
        this.props.setSaveChanges(this.saveChanges);
        this.props.setDiscardChanges(this.discardChanges);
    }
    
    discardChanges(){
        this.setState({ model: Object.assign({}, this.state.initState) ,initState: Object.assign({}, this.state.initState) });
    }

    handleChange(fieldName, newValue) {
        window?.shopify?.saveBar?.show("satcb-save-bar");

        this.setState(prevState => {
            let model = Object.assign({}, prevState.model);
            model[fieldName] = newValue;
            const isDirty = JSON.stringify(this.state.initState) !== JSON.stringify(model);
            this.props.setIsDirty(isDirty);
            if(!isDirty){
                window?.shopify?.saveBar?.hide("satcb-save-bar");
            }
            return { model };
        });
    }

    handlePreview(previewDesktop) {
        this.setState({ previewDesktop: previewDesktop });
        var topNavTimer = setInterval(function(){
            if(window.$('#preview').length > 0){
                setTimeout(function () { window.$('#preview').sticky('update'); }, 0);
            }
        },500);
    }

    togglePreviewActive() {
        this.setState({ previewActive: !this.state.previewActive });
        var topNavTimer = setInterval(function(){
            if(window.$('#preview').length > 0){
                setTimeout(function () { window.$('#preview').sticky('update'); }, 0);
            }
        },500);    }

    render() {

        return (
            this.state.loading ?
                <SkeletonPageCustom />
                :
                <Page title="Quick view">
                    <Layout>
                        <Layout.Section>
                            {this.props.common.hasFreePlanActivated && this.props.common.freePlanClicksUsed <= 0 && (
                                <Banner
                                    title={`Free plan usage Limit Reached: App Paused Until ${(new Date(this.props.common.freePlanCreditsResetDate)).toLocaleString(undefined, {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })}`}
                                    status="critical"
                                    action={{
                                        content: 'Upgrade now', onAction: () => {
                                            const params = new URLSearchParams(this.state.url);
                                            const shop = params.get("shop");
                                            const host = params.get("host");
                                            window.open('/plans?shop=' + shop + '&host=' + host, '_self');
                                        }
                                    }}
                                >
                                    <p>
                                        Your store is currently on the Free plan whose limit is reached and the STKTY app is paused until your next 30-day cycle. Upgrade your plan now to avoid disruptions.
                                    </p>
                                </Banner>
                            )}
                            {this.props.common.hasFreePlanActivated && this.props.common.freePlanClicksUsed > 0 && (
                                <Banner
                                    title={`Free plan usage: ${this.props.common.freePlanClicksUsed >= 0 ? this.props.common.freePlanClicksUsed : 0} clicks left out of 25`}
                                    status="warning"
                                    action={{
                                        content: 'View plans', onAction: () => {
                                            const params = new URLSearchParams(this.state.url);
                                            const shop = params.get("shop");
                                            const host = params.get("host");
                                            window.open('/plans?shop=' + shop + '&host=' + host, '_self');
                                        }
                                    }}
                                >
                                    <p>
                                        Your store is currently on the Free plan. Once 25 clicks are reached, all STKY widgets will be paused until your next 30-day cycle. Upgrade your plan today to avoid disruptions.
                                    </p>
                                </Banner>
                            )}
                        </Layout.Section>
                        <Layout.Section>
                            <Banner
                                title="What is Quick view?"
                                status="info"
                            >
                                <p>Quick view will allow your customers to view details and Add-To-Cart form of any product on any page.</p>
                            </Banner>
                        </Layout.Section>
                        <Layout.Section>
                            <div id="preview" className={(this.state.previewDesktop ? 'desktop' : 'mobile') + (this.state.previewActive ? '' : ' preview-hidden')}>
                                <Card title="Preview" sectioned actions={[{ content: this.state.previewActive ? 'Collapse ↑' : 'Expand ↓', onAction: this.togglePreviewActive }]}>
                                    <Card.Section>
                                        <div id="satcb_quick_view_preview" style={{ display: this.state.previewActive ? 'block' : 'none' }}>
                                            <div className={'satcb_quick_view' + (!this.state.previewDesktop && this.state.model.mobileButtonType === 'round' ? ' satcb-mobile-bt-round' : '') + (' satcb_qv_mobile_' + this.state.model.positionMobile)} style={{ backgroundColor: this.state.model.buttonBackgroundColor, color: this.state.model.buttonColor, borderColor: this.state.model.buttonBorderColor }}>
                                                <span>{this.state.model.quickView_Translation}</span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="13" viewBox="-139 144 20 13"><path d="M-119.3 150.2c-.2-.2-4.4-6-9.8-6s-9.6 5.8-9.8 6c-.2.2-.2.5 0 .8.2.2 4.4 6 9.8 6s9.6-5.8 9.8-6c.1-.3.1-.6 0-.8zm-9.8 5.5c-4 0-7.4-3.8-8.4-5.1 1-1.3 4.4-5.1 8.4-5.1s7.4 3.8 8.4 5.1c-1 1.2-4.4 5.1-8.4 5.1z"></path><path d="M-129.1 146.6c-2.2 0-3.9 1.8-3.9 4s1.8 4 3.9 4c2.2 0 3.9-1.8 3.9-4s-1.7-4-3.9-4zm0 6.6c-1.4 0-2.6-1.2-2.6-2.6 0-1.5 1.2-2.6 2.6-2.6s2.6 1.2 2.6 2.6c0 1.4-1.2 2.6-2.6 2.6z"></path></svg>
                                            </div>
                                        </div>
                                    </Card.Section>
                                    <LegacyStack alignment="center" distribution="center">
                                        <div style={{ display: this.state.previewActive ? 'block' : 'none' }}>
                                            <ButtonGroup segmented con>
                                                <Button pressed={this.state.previewDesktop} onClick={(newValue) => this.handlePreview(true)} icon={DesktopMajor}>Desktop preview</Button>
                                                <Button pressed={!this.state.previewDesktop} onClick={(newValue) => this.handlePreview(false)} icon={MobileMajor}>Mobile preview</Button>
                                            </ButtonGroup>
                                        </div>
                                    </LegacyStack>
                                </Card>
                            </div>
                        </Layout.Section>
                        <Layout.AnnotatedSection
                            title="Quick view state"
                        >
                            <SettingToggle action={{
                                content: this.state.model.enabled ? 'Disable' : 'Enable',
                                onAction: () => { this.handleChange('enabled', !this.state.model.enabled) }
                            }}
                                enabled={this.state.model.enabled}
                            >
                                Quick view is currently <Text as="span" fontWeight="semibold">{this.state.model.enabled ? 'enabled' : 'disabled'}</Text>.
                            </SettingToggle>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection title="Settings">
                            <Card sectioned>
                                <FormLayout>
                                    <Select
                                        label="Button layout on mobile"
                                        options={[{ label: 'Round', value: 'round' }, { label: 'Square', value: 'square' }]}
                                        onChange={(newValue) => this.handleChange('mobileButtonType', newValue)}
                                        value={this.state.model.mobileButtonType}
                                    />
                                    <Select
                                        label="Position on mobile"
                                        options={[{ label: 'Top Right', value: 'top_right' }, { label: 'Bottom Right', value: 'bottom_right' }, { label: 'Top Left', value: 'top_left' }, { label: 'Bottom Left', value: 'bottom_left' }]}
                                        onChange={(newValue) => this.handleChange('positionMobile', newValue)}
                                        value={this.state.model.positionMobile}
                                    />
                                    <LegacyStack vertical spacing="tight">
                                        <LegacyStack wrap={false} alignment="center" spacing="tight">
                                            <Checkbox
                                            label="Enable tracking"
                                            checked={this.state.model.trackingEnabled}
                                            onChange={(newValue) => this.handleChange('trackingEnabled', newValue)}

                                            />
                                            <Tooltip content="This attribute can be used for app auditing and will appear in your Shopify order details page. The attribute name is _Added from Sticky Add To Cart BOOSTER PRO's Quick view. This is not visible to your customers.">
                                            <div style={{ lineHeight: 'normal', marginLeft: '4px' }}>
                                                <Icon source={InfoMinor} color="inkLightest" />
                                            </div>
                                            </Tooltip>
                                        </LegacyStack>
                                    </LegacyStack>
                                    
                                    <TextContainer>
                                        <Banner title="Disabling Quick view">
                                            <p>
                                                To disable Quick view button on a product, add a <b>Quick view disabled</b> tag to it.
                                            </p>
                                        </Banner>
                                    </TextContainer>
                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection
                            title="Translations"
                        >
                            <Card sectioned>
                                <FormLayout>
                                    <FormLayout.Group>
                                        <TextField
                                            value={this.state.model.quickView_Translation}
                                            onChange={(newValue) => this.handleChange('quickView_Translation', newValue)}
                                            label="Quick view"
                                        />
                                        <TextField
                                            value={this.state.model.quantity_Translation}
                                            onChange={(newValue) => this.handleChange('quantity_Translation', newValue)}
                                            label="Quantity"
                                        />
                                    </FormLayout.Group>
                                    <FormLayout.Group>
                                        <TextField
                                            value={this.state.model.addToCart_Translation}
                                            onChange={(newValue) => this.handleChange('addToCart_Translation', newValue)}
                                            label="Add to cart"
                                        />
                                        <TextField
                                            value={this.state.model.buyNow_Translation}
                                            onChange={(newValue) => this.handleChange('buyNow_Translation', newValue)}
                                            label="Buy now"
                                        />
                                    </FormLayout.Group>
                                    <FormLayout.Group>
                                        <TextField
                                            value={this.state.model.soldOut_Translation}
                                            onChange={(newValue) => this.handleChange('soldOut_Translation', newValue)}
                                            label="Sold out"
                                        />
                                        <TextField
                                            value={this.state.model.viewDetails_Translation}
                                            onChange={(newValue) => this.handleChange('viewDetails_Translation', newValue)}
                                            label="View details"
                                        />
                                    </FormLayout.Group>
                                    <FormLayout.Group>
                                        <TextField
                                            value={this.state.model.addedToCartMessage_Translation}
                                            onChange={(newValue) => this.handleChange('addedToCartMessage_Translation', newValue)}
                                            label="Added to cart message"
                                        />
                                        <TextField
                                            value={this.state.model.viewCart_Translation}
                                            onChange={(newValue) => this.handleChange('viewCart_Translation', newValue)}
                                            label="View cart"
                                        />
                                    </FormLayout.Group>
                                    <FormLayout.Group>
                                        <TextField
                                            value={this.state.model.or_Translation}
                                            onChange={(newValue) => this.handleChange('or_Translation', newValue)}
                                            label="or"
                                        />
                                        <TextField
                                            value={this.state.model.continueShopping_Translation}
                                            onChange={(newValue) => this.handleChange('continueShopping_Translation', newValue)}
                                            label="Continue shopping"
                                        />
                                    </FormLayout.Group>
                                </FormLayout>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.AnnotatedSection
                            title="Look and feel"
                        >
                            <Card>
                                <Card.Section title="Quick view button">
                                    <FormLayout>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Text color"
                                                fieldName="buttonColor"
                                                value={this.state.model.buttonColor}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Background color"
                                                fieldName="buttonBackgroundColor"
                                                value={this.state.model.buttonBackgroundColor}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Border color"
                                                fieldName="buttonBorderColor"
                                                value={this.state.model.buttonBorderColor}
                                                handleChange={this.handleChange}
                                            />
                                            <div></div>
                                        </FormLayout.Group>
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section title="Add to cart button">
                                    <FormLayout>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Text color"
                                                fieldName="atcColor"
                                                value={this.state.model.atcColor}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Background color"
                                                fieldName="atcBackgroundColor"
                                                value={this.state.model.atcBackgroundColor}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Border color"
                                                fieldName="atcBorderColor"
                                                value={this.state.model.atcBorderColor}
                                                handleChange={this.handleChange}
                                            />
                                            <div></div>
                                        </FormLayout.Group>
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section title="Buy now button">
                                    <FormLayout>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Text color"
                                                fieldName="buyNowColor"
                                                value={this.state.model.buyNowColor}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Background color"
                                                fieldName="buyNowBackgroundColor"
                                                value={this.state.model.buyNowBackgroundColor}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Border color"
                                                fieldName="buyNowBorderColor"
                                                value={this.state.model.buyNowBorderColor}
                                                handleChange={this.handleChange}
                                            />
                                            <div></div>
                                        </FormLayout.Group>
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section title="View details button">
                                    <FormLayout>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Text color"
                                                fieldName="viewDetailsColor"
                                                value={this.state.model.viewDetailsColor}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Background color"
                                                fieldName="viewDetailsBackgroundColor"
                                                value={this.state.model.viewDetailsBackgroundColor}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Border color"
                                                fieldName="viewDetailsBorderColor"
                                                value={this.state.model.viewDetailsBorderColor}
                                                handleChange={this.handleChange}
                                            />
                                            <div></div>
                                        </FormLayout.Group>
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section title="Product prices">
                                    <FormLayout>
                                        <FormLayout.Group>
                                            <ColorPickerCustom
                                                label="Price color"
                                                fieldName="productPriceColor"
                                                value={this.state.model.productPriceColor}
                                                handleChange={this.handleChange}
                                            />
                                            <ColorPickerCustom
                                                label="Compare price color"
                                                fieldName="productComparePriceColor"
                                                value={this.state.model.productComparePriceColor}
                                                handleChange={this.handleChange}
                                            />
                                        </FormLayout.Group>
                                    </FormLayout>
                                </Card.Section>
                            </Card>
                        </Layout.AnnotatedSection>
                        <Layout.Section>
                            {/*{window.innerWidth < 768 ?*/}
                            {/*<LegacyStack alignment="center" distribution="center">*/}
                            {/*    <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }} />*/}
                            {/*</LegacyStack>    */}
                            {/*: */}
                            {/*    <PageActions primaryAction={{ content: 'Save', onAction: () => { this.saveChanges() } }} />*/}
                            {/*}*/}
                        </Layout.Section>
                    </Layout>
                </Page >
        );
    }

    async populateData() {
        const response = await fetchApi('api/home/quickView');
        const data = await response.json();

        if (data.redirectUrl) {
            this.props.navigate(data.redirectUrl);
        }
        else {
            this.props.setIsLoading(false);
            this.setState({ initState: data, model: data, loading: false });

            var topNavTimer = setInterval(function(){
                if(window.$('#preview').length > 0){
                    window.$('#preview').sticky({ topSpacing: 0, zIndex: 100 });
                }
            },500);
        }
    }

    async saveChanges() {
        this.props.setIsLoading(true);
        const response = await fetchApi('api/home/saveQuickView', { method: 'post', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(this.state.model) });
        const data = await response.json();
        this.props.setIsLoading(false);

        if (response.ok === true) {
            window?.shopify?.saveBar?.hide("satcb-save-bar");

            if (data.redirectUrl) {
                this.props.navigate(data.redirectUrl);
            }
            else {
                this.setState({ initState: Object.assign({}, this.state.model) });
                this.props.setIsDirty(false);
                this.props.setToastActive(true);
            }
        }
    }
}